<template>

  <div
    style="overflow-y: auto;"
    class="container"
  >
    <!-- 高德地图 -->
    <div id="container_details"></div>
    <!-- 高德地图功能组件 -->
    <!-- 基本信息表单 -->
    <div
      class="form-box"
      v-if="data_lists.length!=0"
    >
      <el-form ref="form">
        <el-form-item
          label="公司名称:"
          label-width="125px"
        >
          {{data_lists.company.name}}
        </el-form-item>
        <el-form-item
          label="城市名称:"
          label-width="125px"
        >
          {{data_lists.city.name}}
        </el-form-item>
        <el-form-item
          label="城市标签:"
          label-width="125px"
        >
          {{data_lists.city_tag}}
        </el-form-item>
        <el-form-item
          label="负责人:"
          label-width="125px"
        >
          {{data_lists.boss}}
        </el-form-item>
        <el-form-item
          label="负责人手机号:"
          label-width="125px"
        >
          {{data_lists.phone}}
        </el-form-item>

        <el-form-item
          label="区域编码:"
          label-width="125px"
        >
          {{data_lists.area_code}}
        </el-form-item>
        <el-form-item
          label="城市等级:"
          label-width="125px"
        >
          {{data_lists.level.alias}}
        </el-form-item>

         <el-form-item
          label-width="125px"
        >
          <el-button @click="open">修改城市信息</el-button>
        </el-form-item>



      </el-form>
    </div>
  </div>

</template>

<script>
var _this, district, map;
export default {
    data() {
        return {
            data_lists: []
        };
    },
    created() {
        _this = this;

        _this.$nextTick(function () {
            // 地图初始化
            map = new AMap.Map('container_details', {
                //初始化地图中心点
                center: [116.397428, 39.90923],
                resizeEnable: true, //是否监控地图容器尺寸变化
                zoom: 11 //初始地图级别
            });

            // 获取城市详情
            _this
                .$post('/admin.php/city/getCityDetails')
                .then((res) => {
                    _this.data_lists = res.data;
                    // 判断是否存在绿色围栏数据
                    if (
                        _this.data_lists.free_area_coordinate_array != null &&
                        _this.data_lists.free_area_coordinate_array &&
                        _this.data_lists.free_area_coordinate_array != '' &&
                        _this.data_lists.free_area_coordinate_array != '[]'
                    ) {
                        // 一小时围栏的初始化设置
                        var free_area_polygon = new AMap.Polygon({
                            path: JSON.parse(_this.data_lists.free_area_coordinate_array),
                            strokeColor: 'green',
                            strokeWeight: 6,
                            strokeOpacity: 0.5,
                            fillOpacity: 0.4,
                            fillColor: '',
                            zIndex: 50
                        });

                        // 添加一小时围栏
                        map.add(free_area_polygon);
                        var far_area_polyEditor = new AMap.PolyEditor(map, free_area_polygon);
                    }

                    // 判断是否存在粉色围栏数据
                    if (
                        _this.data_lists.far_area_coordinate_array != null &&
                        _this.data_lists.far_area_coordinate_array &&
                        _this.data_lists.far_area_coordinate_array != '' &&
                        _this.data_lists.far_area_coordinate_array != '[]'
                    ) {
                        // 一小时围栏的初始化设置
                        var far_area_polygon = new AMap.Polygon({
                            path: JSON.parse(_this.data_lists.far_area_coordinate_array),
                            strokeColor: '#FF33FF',
                            strokeWeight: 6,
                            strokeOpacity: 0.5,
                            fillOpacity: 0.4,
                            fillColor: '',
                            zIndex: 50
                        });

                        // 添加一小时围栏
                        map.add(far_area_polygon);
                        var far_area_polyEditor = new AMap.PolyEditor(map, far_area_polygon);
                    }

                    // 判断是否存在黑色围栏数据
                    if (
                        _this.data_lists.effective_area_coordinate_array != null &&
                        _this.data_lists.effective_area_coordinate_array &&
                        _this.data_lists.effective_area_coordinate_array != '' &&
                        _this.data_lists.effective_area_coordinate_array != '[]'
                    ) {
                        // 一小时围栏的初始化设置
                        var effective_area_polygon = new AMap.Polygon({
                            path: JSON.parse(_this.data_lists.effective_area_coordinate_array),
                            strokeColor: 'black',
                            strokeWeight: 6,
                            strokeOpacity: 0.5,
                            fillOpacity: 0.4,
                            fillColor: '',
                            zIndex: 50
                        });

                        // 添加一小时围栏
                        map.add(effective_area_polygon);
                        var far_area_polyEditor = new AMap.PolyEditor(map, effective_area_polygon);
                    }

                    // 缩放地图到合适的视野级别
                    map.setFitView([free_area_polygon]);
                })
                .catch((err) => {});
        });
    },
    methods: {
        open() {
            this.$alert('请联系总经理办公室,获取授权后研发中心将为您进行修改', '', {
                confirmButtonText: '确定',
                callback: (action) => {

                }
            });
        }
    }
};
</script>

<style scoped>
/* 高德地图css */
@import 'https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css';
@import 'https://a.amap.com/jsapi_demos/static/demo-center/css/prety-json.css';
.container {
    height: calc(100vh - 120px);
}
#container_details {
    height: 100%;
    width: 65%;
    float: left;
}

.form-box {
    width: 35%;
    padding: 20px;
    box-sizing: border-box;
    float: left;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
</style>